import React from 'react';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { ColorLabels, Helpers } from '@origin-digital/style-guide';
import styled from 'styled-components';

export interface OriginIconProps extends SvgIconProps {
  'data-id'?: string;
  name?: string;
  color?: ColorLabels;
  disabled?: boolean;
}

function toDashCase(value?: string) {
  if (!value) {
    return '';
  }
  return value.replace(' ', '-');
}

function getDataId(dataId?: string, name?: string, accessibilityLabel?: string, color?: string) {
  if (dataId) {
    return dataId;
  }
  return [color, name, toDashCase(accessibilityLabel)].filter(a => a).join('-');
}

const BaseIcon: React.StatelessComponent<OriginIconProps> = (props: OriginIconProps) => {
  const { children, color: colorLabel = 'lightOrange', name, accessibilityLabel, size = 24, ...other } = props;
  const dataId = getDataId(props['data-id'], name, accessibilityLabel, colorLabel);
  return (
    <SvgIcon
      data-id={dataId}
      color={Helpers.mapColorLabelToHex(colorLabel)}
      size={size}
      accessibilityLabel={accessibilityLabel}
      {...other}
    >
      {children}
    </SvgIcon>
  );
};

export const OriginIcon = styled(BaseIcon)`
  ${({ disabled }) => disabled && 'opacity:0.4'};
  stroke-width: 0;
  vertical-align: middle;
`;
